import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// -------------------------------------------------------------
// Customers
// -------------------------------------------------------------
function CustomersTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [resets, setResets] = useState([]);
  const [resetsLoading, setResetsLoading] = useState(true);
  const [copiedIdx, setCopiedIdx] = useState(-1);

  useEffect(() => {
    axios
      .get(`${API}/admin/customers`)
      .then((r) => setList(r.data))
      .finally(() => setLoading(false));
    axios
      .get(`${API}/admin/password-reset-requests`)
      .then((r) => setResets(Array.isArray(r.data) ? r.data : []))
      .finally(() => setResetsLoading(false));
  }, []);

  const copyLink = async (url, idx) => {
    try {
      await navigator.clipboard.writeText(url);
      setCopiedIdx(idx);
      setTimeout(() => setCopiedIdx(-1), 1600);
    } catch (_) {}
  };

  return (
    <div>
      <h1 className="admin-h1">Customers</h1>
      <p className="admin-sub">Everyone who has registered on your website.</p>
      <div className="admin-card">
        {loading ? (
          <p className="admin-muted">Loading…</p>
        ) : list.length === 0 ? (
          <p className="admin-muted">No customers yet.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Registered</th>
              </tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.email}</td>
                  <td>{c.phone || "—"}</td>
                  <td>{new Date(c.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="admin-card" style={{ marginTop: 24 }} data-testid="password-reset-card">
        <h3>Password reset requests</h3>
        <p className="admin-muted">
          When a customer taps "Forgot password" on the sign-in page, their
          personal reset link shows up here. If email delivery isn't set up yet
          you can copy the link and share it on WhatsApp directly.
        </p>
        {resetsLoading ? (
          <p className="admin-muted">Loading…</p>
        ) : resets.length === 0 ? (
          <p className="admin-muted">No active reset requests right now.</p>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Requested</th>
                <th>Expires</th>
                <th>Reset link</th>
              </tr>
            </thead>
            <tbody>
              {resets.map((r, i) => (
                <tr key={r.reset_url}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{r.name || "—"}</div>
                    <div style={{ fontSize: 12, color: "#8A5427" }}>{r.email}</div>
                  </td>
                  <td>{new Date(r.created_at).toLocaleString()}</td>
                  <td>{new Date(r.expires_at).toLocaleString()}</td>
                  <td style={{ maxWidth: 320 }}>
                    <div
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontFamily: "monospace",
                        fontSize: 12,
                        marginBottom: 6,
                      }}
                      title={r.reset_url}
                    >
                      {r.reset_url}
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline"
                      style={{ padding: "6px 12px", fontSize: 12 }}
                      onClick={() => copyLink(r.reset_url, i)}
                      data-testid={`copy-reset-link-${i}`}
                    >
                      {copiedIdx === i ? "Copied ✓" : "Copy link"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default CustomersTab;
